import { AppConfig } from "./interfaces/config.interfaces";

// config to template of aplication
export const config: AppConfig = {
    color: {
        primary: "#4F8A8B",
        secondary: "#FBD46D",
        background: "#EEEEEE",
        text: "#222831",
    },
    Fonts: {
        Big: "24px",
        Medium: "18px",
        Regular: "16px",
        Small: "14px",
    },
    url: {
        apiBackend: "https://rickandmortyapi.com/api/",
    }
}